import React from "react";
import { Typography, Box } from "@mui/material";

const ProjectIntroduction = () => {
  return (
    <Box
      sx={{
        marginTop: 12,
        alignSelf: "center",
        marginLeft: "auto",
        marginRight: "auto",
      }}
      maxWidth="md"
    >
      <Typography variant="h4">
        TrialScout: AI-Powered Clinical Trial Result Detection
      </Typography>
      <Typography sx={{ marginTop: 2, alignSelf: "center" }}>
        TrialScout is an AI-powered tool developed to address the challenge of
        identifying results for registered clinical trials. Each year, numerous
        trials are completed, yet many do not make their findings publicly
        accessible, hindering scientific progress and informed decision-making.
        TrialScout automates the process of linking trial registrations to their
        results by searching databases like PubMed and parsing the abstracts
        using a Large Language Model.
      </Typography>
    </Box>
  );
};

export default ProjectIntroduction;
